export default __webpack_public_path__ + "static/media/caen9.d2e7cad2.jpg";